import { render } from "./DesignCard.vue?vue&type=template&id=eb07d77e&scoped=true"
import script from "./DesignCard.vue?vue&type=script&lang=ts"
export * from "./DesignCard.vue?vue&type=script&lang=ts"

import "./DesignCard.vue?vue&type=style&index=0&id=eb07d77e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-eb07d77e"

export default script